/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
/* oxlint-disable @typescript-eslint/no-explicit-any, typescript/consistent-type-assertions */
import { useRef } from 'react';
import isShallowEqual from '@jira/platform__is-shallow-equal/src/index.tsx';

/**
 * referential equality check stability helper
 * While "props" of react object are unstable by design, this hook provides a stable reference to the props object.
 * Is not defined for props with children, as children are mostly not stable.
 *
 * Based on shallow equality check.
 *
 * @returns reference to an old object if it is shallow equal to the new one
 */
export function useShallowStableReference<T>(props: T, isEnabled = true): T {
	const ref = useRef(props);

	if (!isEnabled) {
		return props;
	}

	if (!isShallowEqual(props, ref.current)) {
		ref.current = props;
	}
	return ref.current;
}
